import axios from "axios";
import {chainWalk, getAliasFromLoginId, getBaseUrl, getFormattedTimeFromEpoch} from "../Utility";
import {getDocumentURL} from "../handler/ParentDataHandler";
import {HYPHEN} from "../constants";

export async function getPickPackageMetrics(request) {
    const documentUrl = await getDocumentURL();
    const baseURL = getBaseUrl(documentUrl);
    const api = axios.create({baseURL: baseURL});
    const response = await api.post("/rsws/package/metric", request);
    if (response.status === 200) {
        return transformPackageMetrics(response.data.values);
    }
}

export async function getPickPackages(request, baseURL) {
    const api = axios.create({baseURL: baseURL});
    const response = await api.post("/rsws/package/list", request);
    if (response.status === 200) {
        return transformPackages(response.data.packageList);
    }
}

function transformPackageMetrics(groupedPackageMetrics) {
    const metricsMapOutput = {};
    for (const value of groupedPackageMetrics) {
        if (value) {
            const metricList = value.metricList;
            for (const metricObj of metricList) {
                if (metricObj && "PICKED" === metricObj.metric) {
                    metricsMapOutput[value.id] = {
                        "pickedPackages": metricObj.metricValue
                    }
                    break;
                }
            }
        }
    }
    return metricsMapOutput;
}

function transformPackages(packageList) {
    return packageList.map(packageObject => ({
            associateId: getAliasFromLoginId(packageObject.lastScanAssociateId),
            bin: packageObject.bin,
            cluster: packageObject.cluster,
            cycle: packageObject.cycleId,
            ead: getFormattedTimeFromEpoch(packageObject.localEstimatedArrivalDate * 1000),
            lastScan: getFormattedTimeFromEpoch(packageObject.localLastScanTime * 1000),
            location: chainWalk(() => packageObject.packageLocation.scannedLocation, HYPHEN),
            minutesInState: packageObject.minutesInState,
            reason: packageObject.reason,
            routeCode: packageObject.routeCode,
            size: packageObject.size,
            sortZone: packageObject.sortZone,
            state: packageObject.state,
            trackingId: packageObject.trackingId,
            conveyance: chainWalk(() => packageObject.packageLocation.stationPairLabel, HYPHEN),
        })
    );
}



// WEBPACK FOOTER //
// ./src/resources/PickResource.js